module.exports = __webpack_public_path__ + "img/contact11.e53f0451.png";